"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _screenSizes = _interopRequireDefault(require("./screenSizes"));

// copied from aem repo
var Fader = function Fader(targetClassName, offsetWidth, maxFadeWidth, forceMobile, wrap) {
  if (offsetWidth === void 0) {
    offsetWidth = 0;
  }
  if (maxFadeWidth === void 0) {
    maxFadeWidth = Number.POSITIVE_INFINITY;
  }
  if (forceMobile === void 0) {
    forceMobile = false;
  }
  if (wrap === void 0) {
    wrap = false;
  }
  var targetElement = document.querySelector("." + targetClassName);
  if (!targetElement || _screenSizes.default.isMobile() && !forceMobile) {
    return;
  }
  var fadeOffset = offsetWidth || 0;
  var maxWidth = maxFadeWidth || Number.POSITIVE_INFINITY;
  targetElement.classList.add('fader-fade');
  var lDiv = document.createElement('div');
  lDiv.classList.add('fader-container');
  var rDiv = lDiv.cloneNode();
  lDiv.classList.add('fader-container--left');
  rDiv.classList.add('fader-container--right');
  targetElement.insertBefore(lDiv, targetElement.childNodes[0]);
  targetElement.insertBefore(rDiv, null);
  if (wrap) {
    var wrapper = document.createElement('div');
    targetElement.parentNode.insertBefore(wrapper, targetElement);
    wrapper.appendChild(targetElement);
  }
  var scrollCheck = function scrollCheck() {
    if (targetElement.scrollLeft > 0) {
      targetElement.classList.add('fader-fade--left');
      var lWidth = fadeOffset + targetElement.scrollLeft / 2;
      if (lWidth > maxWidth) {
        lDiv.style.width = maxWidth + offsetWidth + "px";
      } else if (targetElement.scrollLeft < 150 - fadeOffset) {
        lDiv.style.width = lWidth + "px";
      } else {
        lDiv.style.width = fadeOffset + 100 + "px";
      }
    } else {
      targetElement.classList.remove('fader-fade--left');
    }
    if (targetElement.scrollLeft + targetElement.clientWidth < targetElement.scrollWidth) {
      targetElement.classList.add('fader-fade--right');
      var scrollPos = targetElement.scrollWidth - (targetElement.scrollLeft + targetElement.clientWidth);
      var rWidth = scrollPos / 2 + fadeOffset;
      if (rWidth > maxWidth) {
        rDiv.style.width = maxWidth + offsetWidth + "px";
      } else if (scrollPos < 150) {
        rDiv.style.width = rWidth + "px";
      } else {
        rDiv.style.width = fadeOffset + 100 + "px";
      }
    } else {
      targetElement.classList.remove('fader-fade--right');
    }
  };
  scrollCheck(); // eslint-disable-next-line consistent-return

  return scrollCheck;
};
var _default = Fader;
exports.default = _default;
module.exports = exports["default"];